export const DAY_NAMES = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
export const HOURS = Array.from(
  {
    length: 27,
  },
  (_, index) => String(index).padStart(2, '0'),
);
export const MINUTES = ['00', '15', '30', '45'];
export const createEmptyOpeningHours = () => {
  return DAY_NAMES.map((name, day) => ({
    day,
    name,
    ranges: [],
  }));
};
export const minutesToTime = (value) => {
  if (value === null || value === undefined || value === '') return '08:00';
  const total = Number(value);
  if (!Number.isFinite(total)) return '08:00';
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
export const timeToMinutes = (value) => {
  const [hours = '0', minutes = '0'] = String(value || '00:00').split(':');
  return Number(hours) * 60 + Number(minutes);
};
export const normalizeOpeningHours = (openingHours = []) => {
  const days = createEmptyOpeningHours();
  openingHours.forEach((item) => {
    const day = Number(item.day);
    if (!Number.isInteger(day) || day < 0 || day > 6) return;
    if (item.isClosed) {
      days[day].ranges = [];
      return;
    }
    days[day].ranges.push({
      open: minutesToTime(item.open),
      close: minutesToTime(item.close),
      isOpen24Hours: Boolean(item.isOpen24Hours),
    });
  });
  return days;
};
export const serializeOpeningHours = (days) => {
  return days.flatMap((day) => {
    if (!day.ranges.length) {
      return [
        {
          day: day.day,
          isClosed: true,
          isOpen24Hours: false,
          open: null,
          close: null,
        },
      ];
    }
    return day.ranges.map((range) => ({
      day: day.day,
      isClosed: false,
      isOpen24Hours: Boolean(range.isOpen24Hours),
      open: range.isOpen24Hours ? null : timeToMinutes(range.open),
      close: range.isOpen24Hours ? null : timeToMinutes(range.close),
    }));
  });
};
